import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Badge, Col, Row, UncontrolledTooltip } from 'reactstrap'
import { AllIncidentsQuery } from "../../Queries"
import Loader from "../../../../../Material/Loader"
import { ReactComponent as InspectionIcon } from '../../../../../assets/images/icons/car-inspection.svg'
import withApolloClient from "../../../../../withApolloClient"
import RenderIncidentDetail from "../../../../../Incidents/RenderIncidentDetail"

class IncidentTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeIncidentId: null
        }
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.allIncidents !== this.props.allIncidents || !this.state.activeIncidentId) && this.props.allIncidents && this.props.allIncidents.edges && this.props.allIncidents.edges.length > 0) {
            this.setState({ activeIncidentId: this.props.allIncidents.edges[0].node.id })
        }
        if ((prevProps.allIncidents !== this.props.allIncidents || (prevProps.activeTab !== this.props.activeTab && this.props.activeTab === "inspections")) && this.props.allIncidents && this.props.allIncidents.edges && this.props.allIncidents.edges.length > 0) {
            if (this.props.location.search) {
                let queryParams = new URLSearchParams(this.props.location.search)
                let incidentId = this.props.allIncidents.edges.find(inspection => inspection.node.id === queryParams.get("incidentId"))
                this.setState({ activeIncidentId: incidentId ? incidentId.node.id : this.props.allIncidents.edges[0].node.id })
            } else {
                this.props.navigate({ hash: this.props.location.hash, search: `incidentId=${this.props.allIncidents.edges[0].node.id}` })
                this.setState({ activeIncidentId: this.props.allIncidents.edges[0].node.id })
            }
        }
    }
    setIncidentId = (id) => {
        const queryString = new URLSearchParams({ "incidentId": id }).toString()
        this.props.navigate({ hash: this.props.location.hash, search: queryString })
        this.setState({ activeIncidentId: id })
    }

    setUrlParams = (id) => {
        const queryString = new URLSearchParams({ "incidentId": this.state.activeIncidentId }).toString()
        this.props.navigate({ hash: this.props.location.hash, search: queryString })
    }

    render() {
        return (
            <div className="inspection-container container-fluid">
                <Row>
                    <Col className="inspections-list" xs={2}>
                        {this.props.loading ? <Loader /> : <>
                            {this.props.allIncidents && this.props.allIncidents.edges && this.props.allIncidents.edges.length > 0 ?
                                this.props.allIncidents.edges.map((incident, i) =>
                                    <div
                                        className={"car-inspection" + (this.state.activeIncidentId === (incident && incident.node && incident.node.id) ? " active" : "")}
                                        onClick={() => this.setIncidentId(incident.node.id)}
                                        key={i}
                                    >
                                        <div className={"sidebar-listing-wrapper-icon"}>
                                            <InspectionIcon width='25' height="25" fill={"red"} />&nbsp;
                                        </div>
                                        <div className={"sidebar-listing-wrapper-text"}>
                                            <p>#{incident.node.pk} - {incident.node.title}</p>
                                            <small>{incident.node?.rental?.car?.pk} - {incident.node?.rental?.car?.vin} {incident.node?.isArchived ? <Badge color="danger">Archived</Badge> : ""}</small>
                                        </div>
                                    </div>
                                ) : <p className="text-center no-rentals">No Incidents Found!</p>
                            }
                            <div className="more-inspections">
                                {this.props.allIncidents && this.props.allIncidents.pageInfo.hasNextPage && <>
                                    <i className={"fa fa-2x fa-arrow-circle-down"} style={{ color: "#1B4D7E" }} onClick={this.props.loadMoreIncidents} aria-hidden="true" id={"viewMore"}></i>
                                    <UncontrolledTooltip target={"viewMore"} placement={"left"}>View More</UncontrolledTooltip>
                                </>
                                }
                            </div>
                        </>}
                    </Col>
                    {this.state.activeIncidentId ?
                        <Col xs={10}>
                            <RenderIncidentDetail id={this.state.activeIncidentId} viewType={"driver"} />
                        </Col> :
                        <Col xs={10}>
                            <p>No Incident Info Found!</p>
                        </Col>
                    }
                </Row>
            </div>
        )
    }
}


//-----------------------------------
export default graphql(AllIncidentsQuery, {
    options: ({ driverId }) => ({ variables: { driverId: driverId, first: 8, orderBy: "-id" }, fetchPolicy: "cache-and-network" }),
    props: ({ data: { allIncidents, fetchMore, loading, variables } }) => (
        {
            allIncidents,
            loading,
            loadMoreIncidents: () => {
                return fetchMore({
                    query: AllIncidentsQuery,
                    variables: {
                        cursor: allIncidents.pageInfo.endCursor,
                        ...variables
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        const newEdges = fetchMoreResult.allIncidents.edges
                        const pageInfo = fetchMoreResult.allIncidents.pageInfo

                        return {
                            allIncidents: {
                                edges: [...previousResult.allIncidents.edges, ...newEdges],
                                pageInfo,
                                __typename: previousResult.allIncidents.__typename
                            },
                        }
                    },
                })
            },
        }
    )
})(withApolloClient(IncidentTab))
